import { format } from "date-fns";

export const BRAND = {
  name: "PinMyDates",
  tagline: "Every Date Matters.",
  headline: "Never Miss What Matters.",
  subheading: "Track birthdays, anniversaries, document expiries, renewals, and deadlines. All in one smart, secure place.",
  slogan: "Pin It. Track It. Never Miss It.",
  founder: "Ahmed Malik",
  email: "pinmydates@gmail.com",
  domain: "pinmydates.com",
  logo: "/brand/APPROVED_LOGO_AND_TAGLINE.jpeg",
  icon: "/brand/icon-128.png",
  iconLarge: "/brand/PinMyDates_icon_512x512.png",
};

export const toDate = (iso) => {
  if (!iso) return null;
  const [y, m, d] = iso.slice(0, 10).split("-").map(Number);
  return new Date(y, m - 1, d);
};

export const fmtDate = (iso, pattern = "MMM d, yyyy") => {
  const d = toDate(iso);
  return d ? format(d, pattern) : "—";
};

export const isoOf = (d) => format(d, "yyyy-MM-dd");

export const daysBetween = (fromIso, toIso) => Math.round((toDate(toIso) - toDate(fromIso)) / 86400000);

export const countdownLabel = (days) =>
  days === 0 ? "Due today" : days > 0 ? `${days} day${days === 1 ? "" : "s"} left` : `${-days} day${days === -1 ? "" : "s"} overdue`;

export const URGENCY = {
  overdue: { label: "Overdue", cls: "bg-[#FDECEE] text-[#C23345]", dot: "#E65363" },
  due_today: { label: "Due today", cls: "bg-[#FDECEE] text-[#C23345]", dot: "#E65363" },
  due_soon: { label: "Due soon", cls: "bg-[#FEF3E2] text-[#A86206]", dot: "#F6AA3E" },
  upcoming: { label: "Upcoming", cls: "bg-[#EFEBFF] text-[#4A31C9]", dot: "#5439DC" },
  completed: { label: "Completed", cls: "bg-[#E3F6F1] text-[#137A62]", dot: "#1CA786" },
  archived: { label: "Archived", cls: "bg-[#F0EFF4] text-[#5F5C70]", dot: "#9A97AB" },
};

export const RECURRENCE_LABELS = {
  one_time: "One-time", daily: "Daily", weekly: "Weekly", monthly: "Monthly", quarterly: "Quarterly", yearly: "Yearly",
};

export const ENTITY_KINDS = [
  { value: "person", label: "Person", group: "people" },
  { value: "family", label: "Family member", group: "people" },
  { value: "staff", label: "Staff", group: "people" },
  { value: "vehicle", label: "Vehicle", group: "assets" },
  { value: "property", label: "Property", group: "assets" },
  { value: "organization", label: "Organization", group: "assets" },
  { value: "custom", label: "Other", group: "assets" },
];

export const fmtBytes = (b) => (b < 1024 * 1024 ? `${b ? Math.max(1, Math.round(b / 1024)) : 0} KB` : `${(b / 1024 / 1024).toFixed(1)} MB`);
